import { reactive } from 'vue'

// 全局咨询弹窗状态：任意页面按钮调用 openInquiry() 即可弹出
export const inquiryState = reactive({
  visible: false
})

export function openInquiry() {
  inquiryState.visible = true
}

export function closeInquiry() {
  inquiryState.visible = false
}
